import { computed, Ref, WritableComputedRef } from 'vue';
import { HekateDisplayField, HekateDisplayFieldInteractiveStateType } from 'www-shared';

export default class FieldUtil {
  /** Bubble the model update:modelValue up */
  public static bubbleModel({
    get,
    emitter,
  }: {
    get: () => string | boolean,
    emitter: {
      emit: (eventName: string, eventVal: string | boolean) => void
    },
  }): WritableComputedRef<string | boolean> {
    const bubbleModel = computed({
      get,
      set: (evt) => {
        emitter.emit('update:modelValue', evt);
      },
    });

    return bubbleModel;
  }

  /** Create a function that sends a blur event after a delay */
  public static lateBlur({
    field,
    emitter,
  }: {
    field: Ref<HekateDisplayField>,
    emitter: {
      emit: (eventName: string, eventVal: HekateDisplayField) => void
    },
  }): () => void {
    return () => {
      setTimeout(() => {
        emitter.emit('blur', field.value);
      }, 25);
    };
  }

  /** Set the interactive state. */
  public static setInteractiveState({
    newState,
    field,
  }: {
    newState: HekateDisplayFieldInteractiveStateType
    field: Ref<HekateDisplayField>,
  }): void {
    field.value.interactiveState = newState;
  }
}
